import React from "react";
import { Col, Row } from "design-react-kit";
import { ValidatedForm, FormEnabler, MFile, MLabel, MInput } from "components/forms";
import { dateHelper } from "libs";

class TirocinioDirettoStep4 extends ValidatedForm {
  emptyFields = {
    numHours: "",
    dateStart: "",
    dateEnd: "",
  };

  state = {
    ...this.emptyFields,
    defaultValues: { ...this.emptyFields },
  };

  FIELDS_GROUP = [
    [
      {
        id: "numHours",
        field: "numHours",
        label: "Numero ore tirocinio",
        component: MInput,
        type: "number",
        className: "col-md-4 mt-2",
      },
      {
        id: "dateStart",
        field: "dateStart",
        label: "Data inizio tirocinio",
        component: MInput,
        type: "date",
        className: "col-md-4 mt-2",
      },
      {
        id: "dateEnd",
        field: "dateEnd",
        label: "Data fine tirocinio",
        component: MInput,
        type: "date",
        className: "col-md-4 mt-2",
      },
    ],
    [
      {
        field: "relazioneFinale",
        label: "Relazione finale",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "relazioneFinaleFile",
        field: "document",
        label: "Relazione finale",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "relazioneFinale",
        },
        className: "col-md-12",
      },
    ],
    [
      {
        field: "registroPresenze",
        label: "Registro presenze",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "registroPresenzeFile",
        field: "document",
        label: "Registro presenze",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.p7m,.xml,.doc,.docx",
          code: "registroPresenze",
        },
        className: "col-md-12 p-0 m-0",
      },
    ],
    [
      {
        field: "grigliaAutovalutazione",
        label: "Griglia di autovalutazione",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "grigliaAutovalutazioneFile",
        field: "document",
        label: "Griglia di autovalutazione",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 2,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "grigliaAutovalutazione",
        },
        className: "col-md-12",
      },
    ],
  ];

  ERROR_MESSAGES = {
    numHours: "Inserire un numero di ore valido tra 1 e 180",
    dateStart: "Inserire una data di inizio del tirocinio valida",
    dateEnd: "Inserire una data di fine del tirocinio valida",
  };

  validation = {
    numHours: (value) => {
      const num = parseInt(value);
      return value !== "" && !isNaN(num) && num > 0 && num <= 180;
    },
    dateStart: (value) => {
      if (value === "") return false;
      return dateHelper.noFuture(value);
    },
    dateEnd: (value, state) => {
      const dateStart = state.dateStart.value;
      return value !== "" && (!dateStart || value >= dateStart);
    },
  };

  componentDidMount() {
    const { defaultValues } = this.props;

    if (defaultValues) {
      this.setState({ ...defaultValues, defaultValues });
    }
  }

  onSubmit = (e) => {
    if (e) e.preventDefault();

    if (!this.checkValidation()) return;

    const questions = this.FIELDS_GROUP.flat()
      .filter((f) => f.id && this.state[f.id] !== undefined)
      .map((f) => ({
        field: f.field,
        question: f.label,
        answer: this.state[f.id]?.value ?? this.state[f.id],
        type: "text",
      }));

    this.props.onSubmit(questions);
  };

  render() {
    const { tirocinioDiretto, formActive, onToggleEdit } = this.props;
    const { defaultValues } = this.state;

    const status = tirocinioDiretto?.status;
    const { formValid, code } = this.renderFields(this.FIELDS_GROUP, defaultValues, formActive);
    const enableSave = formValid || status === "revisionPending";

    return (
      <Row>
        <Col className="col-12 mt-3">
          <form className="mt-3">{code}</form>
          <FormEnabler isFormActive={formActive} disableSave={!enableSave} onSubmit={this.onSubmit} onCancel={onToggleEdit} />
        </Col>
      </Row>
    );
  }
}

export default TirocinioDirettoStep4;
